module.exports = __webpack_public_path__ + "static/media/pistol-poem2.5fd27a36.jpg";